/* ==========================================================================
   Support widgets: Intercom (чат) і Ringostat (зворотний дзвінок) на вимогу.
   Скрипти віджетів НЕ вантажаться при відкритті сторінки; кнопки малює
   FloatActions (floatActions.js), а сторонній скрипт підтягується лише по
   кліку. Конфіг приходить із PHP у window.WS_FA_CONFIG:
     { intercom: { app_id }, ringostat: { src }, t: { 'fa.support.label': … }, options: {…} }
   Публічно: window.WS_FA.open('support' | 'ringostat' | 'telegram'), WS_FA.close(id), WS_FA.fa
   ========================================================================== */
(function (w, d) {
	'use strict';

	var cfg = w.WS_FA_CONFIG;
	if (!cfg) return;

	var body = d.body;
	// ті самі сторінки, де старі CSS-правила ховали лаунчери Intercom/Ringostat:
	// плаваючі кнопки там не малюємо, але WS_FA.open() має працювати завжди —
	// на нього зав'язані кнопки в контенті (data-onclick="intercom", напр. support.html)
	var off = ['logged', 'page-register', 'page-partner', 'partner'].some(function (c) { return body.classList.contains(c); });

	var fa = null;
	if (!off && typeof w.FloatActions === 'function') {
		var actions = [];
		// Telegram-бот зверху: звичайне посилання (href з PHP уже з ?start=<мова>_<сторінка>), без віджета
		if (cfg.telegram && cfg.telegram.href) actions.push({ id: 'telegram', icon: 'telegram', label: 'fa.telegram.label' });
		actions.push({ id: 'support', icon: 'chat', label: 'fa.support.label' });
		// Ringostat: як у GTM-тезі — лише від 768px і не для мобільної версії
		var phoneOk = cfg.ringostat && cfg.ringostat.src && w.innerWidth >= 768 && !body.classList.contains('mobile');
		if (phoneOk) actions.push({ id: 'ringostat', icon: 'phone', label: 'fa.ringostat.label' });

		// Футер (data-fa-avoid): на десктопі кнопки піднімаються над ним ('lift'); на мобільному футер
		// висотою в кілька екранів і 'lift' затягує кнопки під самий верх, тому там їх просто ховаємо ('hide')
		var COMPACT_BELOW = 640;
		var compactMq = w.matchMedia('(max-width: ' + (COMPACT_BELOW - 1) + 'px)');
		var avoidMode = function () { return compactMq.matches ? 'hide' : 'lift'; };

		fa = new w.FloatActions(body, Object.assign({
			actions: actions,
			t: cfg.t || {},
			labels: false, // тултіпи при наведенні вимкнені; щоб увімкнути — labels: true (підписи беруться з cfg.t)
			nudge: false,
			compactBelow: COMPACT_BELOW,
			avoidMode: avoidMode(),
			onAction: function (id) { open(id); },
			onClose: function (id) { close(id); },
		}, cfg.options || {}));

		(compactMq.addEventListener ? compactMq.addEventListener.bind(compactMq, 'change') : compactMq.addListener.bind(compactMq))(function () {
			fa.setOptions({ avoidMode: avoidMode() });
		});
	}

	// стан плаваючої кнопки; без кнопок (fa === null) — no-op
	function ui(method, id) { if (fa) fa[method](id); }

	function script(src) {
		return new Promise(function (resolve, reject) {
			var s = d.createElement('script');
			s.async = true;
			s.src = src;
			s.onload = resolve;
			s.onerror = function () { reject(new Error('failed to load ' + src)); };
			d.head.appendChild(s);
		});
	}

	/* ---- Intercom ------------------------------------------------------- */

	var intercomReady = null;

	function loadIntercom() {
		if (intercomReady) return intercomReady;
		var settings = {
			app_id: cfg.intercom.app_id,
			language_override: d.documentElement.lang || undefined,
			hide_default_launcher: true,
			// месенджер сідає над нашими кнопками (56px + 24px відступу + 16px)
			horizontal_padding: 24,
			vertical_padding: 96,
		};
		w.intercomSettings = settings;

		if (typeof w.Intercom === 'function' && w.Intercom.booted) {
			// хтось (напр. GTM) уже підняв Intercom — лише ховаємо його лаунчер
			w.Intercom('update', settings);
			intercomReady = Promise.resolve();
		} else {
			// стандартна черга Intercom: виклики до завантаження скрипта накопичуються
			var q = function () { q.c(arguments); };
			q.q = [];
			q.c = function (args) { q.q.push(args); };
			w.Intercom = q;
			intercomReady = script('https://widget.intercom.io/widget/' + cfg.intercom.app_id).then(function () {
				w.Intercom('boot', settings);
			});
		}
		return intercomReady.then(function () {
			w.Intercom('onShow', function () { ui('active', 'support'); });
			w.Intercom('onHide', function () { ui('idle', 'support'); });
		});
	}

	/* ---- Ringostat ------------------------------------------------------ */

	var ringostatReady = null;

	function loadRingostat() {
		if (ringostatReady) return ringostatReady;
		// скрипт уже на сторінці (напр. з GTM) — не вантажимо вдруге
		var present = (w.ringostatAPI && typeof w.ringostatAPI.openCallbackForm === 'function')
			|| !!d.querySelector('script[src*="script.ringostat.com"]');
		ringostatReady = (present ? Promise.resolve() : script(cfg.ringostat.src)).then(function () {
			// ringostatAPI з'являється не одразу після onload
			return new Promise(function (resolve, reject) {
				var started = Date.now();
				(function wait() {
					if (w.ringostatAPI && typeof w.ringostatAPI.openCallbackForm === 'function') return resolve();
					if (Date.now() - started > 15000) return reject(new Error('ringostatAPI timeout'));
					setTimeout(wait, 100);
				})();
			});
		}).then(function () {
			// як у GTM-тезі: хіт перегляду для аналітики Ringostat (лише якщо скрипт вантажили ми)
			if (!present && w.ringostatAnalytics && typeof w.ringostatAnalytics.sendHit === 'function') {
				try { w.ringostatAnalytics.sendHit('pageview'); } catch (e) {}
			}
		});
		return ringostatReady;
	}

	// форма Ringostat живе в #wrapper_id (iframe); стежимо за появою/зникненням
	new MutationObserver(function (muts) {
		muts.forEach(function (m) {
			m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && n.id === 'wrapper_id') ui('active', 'ringostat'); });
			m.removedNodes.forEach(function (n) { if (n.nodeType === 1 && n.id === 'wrapper_id') ui('idle', 'ringostat'); });
		});
	}).observe(body, { childList: true });

	function closeRingostat() {
		var wrap = d.getElementById('wrapper_id');
		if (!wrap) return;
		try {
			// хрестик форми слухає mousedown усередині iframe
			var doc = wrap.querySelector('iframe').contentDocument;
			var x = doc && doc.getElementById('rngst_close');
			if (x) { x.dispatchEvent(new MouseEvent('mousedown', { bubbles: true })); return; }
		} catch (e) {}
		wrap.parentNode && wrap.parentNode.removeChild(wrap);
	}

	/* ---- public --------------------------------------------------------- */

	function open(id) {
		if (id === 'telegram') {
			w.open(cfg.telegram.href, '_blank', 'noopener');
			ui('idle', 'telegram'); // зовнішнє посилання: стану «відкрито» немає
			return;
		}
		if (id === 'support') {
			ui('loading', 'support');
			loadIntercom().then(function () { w.Intercom('show'); }).catch(function () { ui('idle', 'support'); });
		} else if (id === 'ringostat') {
			if (!cfg.ringostat || !cfg.ringostat.src) return;
			ui('loading', 'ringostat');
			loadRingostat().then(function () {
				w.ringostatAPI.openCallbackForm();
				// якщо форма так і не з'явилась (напр. Ringostat вирішив не показувати) — знімаємо спінер
				setTimeout(function () { if (!d.getElementById('wrapper_id')) ui('idle', 'ringostat'); }, 8000);
			}).catch(function () { ui('idle', 'ringostat'); });
		}
	}

	function close(id) {
		if (id === 'support' && typeof w.Intercom === 'function') w.Intercom('hide');
		if (id === 'ringostat') closeRingostat();
		ui('idle', id);
	}

	w.WS_FA = { fa: fa, open: open, close: close };
})(window, document);
